import {toLocaleNumber} from "../../number";

/**
 * @function yearColumnsTariff
 * @description Get the columns for the year statement.
 * @param {Function} gettext - The gettext function.
 * @param {String} locale - The locale.
 * @returns {Object[]} - The columns.
 */
export const yearColumnsTariff = (gettext, locale) => {
  return [
    {
      field: "meter",
      headerName: gettext("Order No"),
      width: 200,
    },
    {
      field: "meterNumber",
      headerName: gettext("Meter No"),
      width: 150,
    },
    {
      field: "customer",
      headerName: gettext("Company"),
      width: 250,
    },
    // {
    //   field: "address",
    //   headerName: gettext("Address"),
    //   width: 300,
    // },
    {
      field: "streetName",
      headerName: gettext("Street"),
      width: 200,
    },
    {
      field: "buildingNumber",
      headerName: gettext("House No."),
      width: 100,
    },
    {
      field: "postcode",
      headerName: gettext("Zip Code"),
      width: 100,
    },
    {
      field: "cityName",
      headerName: gettext("City"),
      width: 150,
    },
    {
      field: "consumerCVR",
      headerName: gettext("Company No."),
      width: 100,
    },
    {
      field: "gridOperatorName",
      headerName: gettext("Grid company"),
      width: 120,
    },
    // {
    //   field: "inkl_moms",
    //   headerName: gettext("Inkl. Moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "moms",
    //   headerName: gettext("Moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "ekskl_moms",
    //   headerName: gettext("Ekskl. moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    {
      field: "elagift",
      headerName: gettext("Samlet elafgift"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "godtgorelsessats",
      headerName: gettext("Godtgørelse"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "minimumsafgift",
      headerName: gettext("Minimumsafgift"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "tsoSystemAbonnement",
      headerName: gettext("TSO - System abonnement"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "systemtarif",
      headerName: gettext("Systemtarif"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "transmissionsNettarif",
      headerName: gettext("Transmissions nettarif"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "nettariff",
      headerName: gettext("Nettarifs"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "rabatNettariff",
      headerName: gettext("Rabat Tariffs"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "abonnement",
      headerName: gettext("Abonnement"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "rabatAbonnement",
      headerName: gettext("Rabat abonnement"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "netFast",
      headerName: gettext("Rådighedsbetaling"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    {
      field: "consumption",
      headerName: gettext("kWh"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    },
    // {
    //   field: "sep",
    //   headerName: gettext("Sep"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "oct",
    //   headerName: gettext("Oct"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "nov",
    //   headerName: gettext("Nov"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "dec",
    //   headerName: gettext("Dec"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
  ];
};
